export const getters = {
  deadsaleItemsrows: state => state.dead_sale_items,
  systemDeadSales: state => state.deadsales
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/deadsales/getters.js